export default "__VITE_ASSET__BnsXNFEK__"